import { Injectable, Inject } from 'ng-metadata/core';

@Injectable()
export class PartiallyTranslatedFieldsUtil {

    constructor(
        @Inject('$q') private $q: ng.IQService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService) {
    }

    public handlePartiallyTranslatedFacet(facet, useTranslation: Boolean): Promise<string> {
        return this.$q((resolve, reject) => {
            if (!facet) {
                reject();
            }
            if (useTranslation) {
                this.parsePartiallyTranslatedField(facet.value).then((parsedVal) => {
                    facet.tooltip = this.$translate.instant('nui.facets.remove.tooltip') + this.$translate.instant('fulldisplay.' + facet.name) + ' ' + parsedVal;
                    resolve(parsedVal);
                })
            } else {
                resolve(this.removeTranslationTags(facet.value));
            }
        })
    }

    public async parsePartiallyTranslatedField(value): Promise<string> {
        if (!value) {
            throw 'Error on field partial translation';
        }
        let translationRegex = /\$\$T[^\$]*(\$\$)/g;
        let translationMatches = value.match(translationRegex);
        if (translationMatches) {
            for(let translationMatch of translationMatches){
                let valueToTranslate = translationMatch.replace('$$T', '').replace('$$', '');
                let translation = await this.$translate(valueToTranslate.toLowerCase());
                value = value.replace(translationMatch, translation);
            }
        }
        return value;
    }

    public parsePartiallyTranslatedFieldInstant(value): string {
        if (!value) {
            throw 'Error on field partial translation';
        }
        let translationRegex = /\$\$T[^\$]*(\$\$)/g;
        let translationMatches = value.match(translationRegex);
        if (translationMatches) {
            for(let translationMatch of translationMatches){
                let valueToTranslate = translationMatch.replace('$$T', '').replace('$$', '');
                let translation = this.$translate.instant(valueToTranslate.toLowerCase());
                value = value.replace(translationMatch, translation);
            }
        }
        return value;
    }

    public removeTranslationTags(value: string): string {
        let translationTagRegex = /\$\$T[^\$]*(\$\$)/g;
        let translationTagMatches = value.match(translationTagRegex);
        if (translationTagMatches) {
            for(let translationTagMatch of translationTagMatches){
                let valueToReplace = translationTagMatch.replace('$$T', '').replace('$$', '');
                value = value.replace(translationTagMatch, valueToReplace);
            }
        }
        return value;
    }

    public isPartiallyTranslated(value: string): Boolean {
        if (value) {
            return value.indexOf("$$T") > -1;
        }
        return false;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/partiallyTranslatedFieldsUtil.service.ts